export const StackSetData = (
  data,
  {
    getContentHeight,
    standardPageHeight
  }
) => {
  if (!data?.length) return [];

  let leftHeight = 0;
  let rightHeight = 0;
  let currentSide = 'left';
  let isFirstStack = true;
  let headerHeight = getContentHeight('header');
  let stackCounter = 0;
  let activeStack = null;
  let currentStackMaxHeight = 0;
  let updatedData = [...data];

  updatedData.forEach((item, index) => {
    const questionHeight = getContentHeight(item.id ? item.id : item.questionId);
    let pageHeight = standardPageHeight;

    if (isFirstStack)
      pageHeight -= headerHeight;

    const effectivePageHeight = Math.max(pageHeight, currentStackMaxHeight);
    let position = currentSide;

    if (activeStack === null) {
      stackCounter += 1;
      activeStack = stackCounter;
      currentStackMaxHeight = 0;
    }

    if (currentSide === 'left') {
      if (leftHeight === 0 || leftHeight + questionHeight <= effectivePageHeight) {
        leftHeight += questionHeight;
        position = 'left';
        currentStackMaxHeight = Math.max(currentStackMaxHeight, leftHeight);
      } else {
        currentSide = 'right';
        rightHeight = questionHeight;
        position = 'right';
        currentStackMaxHeight = Math.max(currentStackMaxHeight, rightHeight);
      }
    }
    else {
      if (rightHeight + questionHeight <= effectivePageHeight) {
        rightHeight += questionHeight;
        position = 'right';

        currentStackMaxHeight = Math.max(
          currentStackMaxHeight,
          rightHeight
        );

      } else {
        if (index !== 0)
          updatedData[index - 1].isEndStack = true;

        leftHeight = questionHeight;
        rightHeight = 0;
        currentSide = 'left';
        position = 'left';
        isFirstStack = false;
        activeStack = null;
        stackCounter += 1;
        activeStack = stackCounter;
        currentStackMaxHeight = leftHeight;
      }
    }

    updatedData[index] = { ...item, position, stackNo: activeStack };
  });

  if (updatedData.length > 0)
    updatedData[updatedData.length - 1].isEndStack = true;

  return updatedData;
};

export const DeStackSetData = (data) => {
  if (!data?.length) return [];
  // eslint-disable-next-line no-unused-vars
  return data.map(({ position, isEndStack, stackNo, ...rest }) => ({
    ...rest
  }));
};

export const ResetSettings = (originalSettingsData) => {
  let updatedSettings = originalSettingsData;
  updatedSettings.fontStyle = 'Times New Roman';
  updatedSettings.fontSize = 12;
  updatedSettings.hideDefinition = false;
  updatedSettings.imageCompressionPercent = 50;
  updatedSettings.showNameLine = true;
  updatedSettings.showTeacherName = true;
  updatedSettings.twoColumn = false;
  return updatedSettings;
};